/**************************************************
 * Nombre:       Formulario_Pasos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {SpaceBar,Numbers,Title} from "@mui/icons-material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import IngresoImagenCrop from "../../../Modulo_formularios/Componentes/IngresoImagenCrop";

const Formulario_Pasos = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={12} sx={{justifyContent: 'flex-start'}}>
                    <IngresoImagenCrop ancho={4}  alto={3} {...props} dato={'img'}/>
                </Grid>

                <Grid container size={12} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto Icono={Numbers} nombre={'Perido'} {...props} dato={'periodo'}/>
                </Grid>


                <Grid container size={12} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto Icono={Title} nombre={'Titulo'} {...props} dato={'nombre'}/>
                </Grid>


                <Grid container size={12} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto lineas={4} nombre={'Parrafo descripcion'} {...props} dato={'descripcion'}/>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Pasos